import { render, staticRenderFns } from "./dust.vue?vue&type=template&id=bc61216a&scoped=true&"
import script from "./dust.vue?vue&type=script&lang=js&"
export * from "./dust.vue?vue&type=script&lang=js&"
import style0 from "./dust.vue?vue&type=style&index=0&id=bc61216a&scoped=true&lang=css&"
import style1 from "./dust.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc61216a",
  null
  
)

export default component.exports